import { GoogleMapsLocationService } from './googleMapsLocationService';
import { LocationService } from './location';

let locationService: LocationService | null = null;

export function useLocationService(options?: {
  serviceInstance?: LocationService;
}): LocationService {
  if (options?.serviceInstance) {
    locationService = options.serviceInstance;
    return options.serviceInstance;
  }

  if (!locationService) {
    locationService = new GoogleMapsLocationService();
  }
  return locationService;
}
